
import { os } from "~/data/siem";
export default {
  data() {
    return {
      operationSystems: os,
      activeIndex: 0,
    };
  },
};
